module.exports = __webpack_public_path__ + "media/ip-1.ad1a09eb.mp4";